import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const EditLevel = () => {
  const [formValues, setFormValues] = useState({
    courseCategoryName: "",
    department_id: "",
  });

  const location = useLocation();
  const levelToEdit = location.state?.level;

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedDepartment, setSelectedDepartment] = useState("");

  const [filteredSubcategories, setFilteredSubcategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [departments, setDepartments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // console.log("Passed level to edit: ", levelToEdit);
    if (levelToEdit) {
      // console.log("level details: ", levelToEdit);

      setFormValues((prev) => ({
        ...prev,
        courseCategoryName: levelToEdit.courseCategoryName,
        department_id: levelToEdit.department._id,
      }));
    }
    // setSelectedDepartment(levelToEdit.department_id)

    const fetchdepartment = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setDepartments(response.data.data);
        // console.log(response.data.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchdepartment();
  }, [levelToEdit]);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/update-course-category/${levelToEdit._id}`,
        formValues,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // console.log(response);

      if (response.status === 200) {
        setSnackbarMessage("Updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/level-list");
        }, 2000);
      }
    } catch (err) {
      // Check for 400 status error
      if (err.response && err.response.status === 400) {
        alert("Please fill out all required fields...");
      } else {
        setSnackbarMessage("Failed to update. Please try again");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={(e)=>handleFormSubmit(e)}>
              <div className="mb-20">
                <label
                  htmlFor="depart"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Department
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="depart"
                  value={formValues.department_id}
                  required
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      department_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a Department
                  </option>
                  {departments.map((department) => (
                    <option key={department._id} value={department._id}>
                      {department.department_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-20">
                <label
                  htmlFor="text"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Level Name
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  required
                  className="form-control radius-8"
                  id="text"
                  placeholder="Enter category name"
                  value={formValues.courseCategoryName}
                  onChange={(e) =>{
                    const value = e.target.value;
                    if(value===""||value.trim()!==""){
                    setFormValues({
                      ...formValues,
                      courseCategoryName: e.target.value,
                    })}
                  }}
                />
              </div>

              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/level-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  // onClick={(e) => handleFormSubmit(e)}
                >
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditLevel;
